import sanitize from 'sanitize-html';

import { allowedTags, allowedAttributes } from './sanitize-config';

export default {
  name: 'WmSanitizeHtml',

  props: {
    innerHtml: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'div',
    },
  },

  render(h) {
    return h(this.tag, {
      domProps: {
        innerHTML: sanitize(this.innerHtml, {
          allowedTags,
          allowedAttributes,
        }),
      },
    });
  },
};
